import React, { useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import FeaturesSection from '../components/sections/features-section';
import CtaSection from '../components/sections/cta-section';

const FeaturesPageContainer = styled.div`
  padding-top: 5rem;
`;

const HeroSection = styled.section`
  background: ${({ theme }) => theme.colors.gradient.primary};
  color: white;
  padding: 10rem 1rem 8rem;
  text-align: center;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -20%;
    width: 80%;
    height: 200%;
    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%);
    z-index: 1;
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: -50%;
    right: -20%;
    width: 80%;
    height: 200%;
    background: radial-gradient(circle, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0) 70%);
    z-index: 1;
  }
`;

const HeroContent = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`;

const PageTitle = styled(motion.h1)`
  font-size: 4rem;
  font-weight: 800;
  margin-bottom: 1.5rem;
  line-height: 1.1;
  letter-spacing: -0.03em;
  position: relative;
  z-index: 2;
  
  span {
    background: ${({ theme }) => theme.colors.gradient.secondary};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    position: relative;
    display: inline-block;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 3rem;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 2.25rem;
  }
`;

const PageDescription = styled(motion.p)`
  font-size: 1.25rem;
  max-width: 700px;
  margin: 0 auto 3rem;
  opacity: 0.9;
  line-height: 1.6;
  position: relative;
  z-index: 2;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 1.125rem;
    max-width: 600px;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 1rem;
  }
`;

const FeaturesPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Features | FylePrep';
    window.scrollTo(0, 0);
  }, []);

  return (
    <FeaturesPageContainer>
      <HeroSection>
        <HeroContent>
          <PageTitle
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            Meet Your <span>AI-Enabled</span> Tax Co-Pilot
          </PageTitle>
          
          <PageDescription
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            FylePrep leverages cutting-edge AI to automate document classification, extract key tax data,
            and streamline your entire preparation workflow. Save hours on every return.
          </PageDescription>
        </HeroContent>
      </HeroSection>
      
      <FeaturesSection />
      <CtaSection />
    </FeaturesPageContainer>
  );
};

export default FeaturesPage;
